export interface Hit {
  id: number
  objectID: string,
  topic_url: string,
  url: string,
  title: string,
  forum: number,
  forum_title: string,
  content_type: TopicContentType,
  category_id: number,
  category_title: string,
  has_answer: boolean,
  article_label: string
  _highlightResult?: object
}

export interface ZendeskHit {
  url: string,
  title: string,
  content: string
}

export function isZendeskResult (el: Hit | ZendeskHit): el is ZendeskHit {
  return el.hasOwnProperty('title') && (el.hasOwnProperty('content') || el.hasOwnProperty('body'))
}

export type SearchType = 'zendesk' | 'community'

export interface DoSearch {
  (input: string): void
}

export interface GetItemPropsFn {
  (data: {item: Hit, index: number}): {}
}

export interface SearchResults {
  hitsPerPage: number,
  page: number,
  queryID: string,
  nbHits: number,
  hits: Array<Hit>,
  nbPages: number,
  query: string
}

export type AllSearchResults = {
  [index: string]: SearchResults | undefined
}

export interface TopicClickedEvent {
  type: 'Topic Clicked',
  topic_url: string,
  click_source: string,
  topic_position: number,
  topic_title: string,
  topic_topic_type: string,
  category_id?: number,
  category_title?: string,
}


export interface TopicClickedGoogleAnalyticsEvent {
    eventCategory: 'Live Search',
    eventAction: 'Topic Clicked',
    eventLabel: {
      Link: string,
      Position: number,
      Type: SearchType | TopicContentType
    }
}
